<template>
  <mvtDropdownList
      size="small"
      :btnClass="`mvt-dropdown__toggle btn filter small toggle ${filterRedesignEnabled ? 'square' : ''}`"
      :items="sortByData"
      :label="sortBy ? null : sortByData[0].labelText"
      :defaultValue="sortByData[0].value"
      :hideReset="true"
      v-model="sortBy"
  />
</template>

<style lang='scss'>
  .mvt-dropdown__toggle .icon-sort-down {
    position: relative;
    top: 2px;
  }
</style>

<script src="./search-sort.js"></script>